jQuery(function ($) {
   
    /* ---------------------------
       Mobile Menu Toggle
    ---------------------------- */
    const mobileNav = document.querySelector('.mobile_nav');
    if (mobileNav) {
        mobileNav.addEventListener('click', function () {
            document.body.classList.toggle('mobile_nav-opened');
        });
    }

    /* Page Up Button */
    const btnToTop = document.createElement('div');

    btnToTop.style.position = 'fixed';
    btnToTop.style.bottom = '5%';
    btnToTop.style.right = '0';
    btnToTop.style.backgroundColor = '#000';
    btnToTop.style.color = '#e7e7e7';
    btnToTop.style.width = '50px';
    btnToTop.style.height = '50px';
    btnToTop.style.borderRadius = '5px 0 0 5px';
    btnToTop.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.3)';
    btnToTop.style.zIndex = '1000';
    btnToTop.style.cursor = 'pointer';
    btnToTop.style.display = 'flex';
    btnToTop.style.alignItems = 'center';
    btnToTop.style.justifyContent = 'center';
    btnToTop.style.opacity = '0.6';
    btnToTop.style.webkitTapHighlightColor = 'transparent';

    btnToTop.addEventListener('mouseover', () => {
        btnToTop.style.opacity = '0.8';
    });

    btnToTop.addEventListener('mouseout', () => {
        btnToTop.style.opacity = '0.6';
    });

    btnToTop.addEventListener('click', (event) => {

        event.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        // Remove focus after click/tap
        if (document.activeElement) {
            document.activeElement.blur();
        }

    });


    /* Icon */
    const icon = document.createElement('span');

    icon.className = 'et-pb-icon';
    icon.style.fontSize = '25px';
    icon.style.lineHeight = '0';
    icon.innerHTML = '&#x3a;';

    btnToTop.appendChild(icon);

    document.body.appendChild(btnToTop);

});


;(function ( $, window, document, undefined ) {
    
    window.ceOptInMediaWrapper = {

        loaded : false,

        cookiePrefix: function() {
            return 'ce-gprd-agree_';
        },

        initialize: function() {
            if ( true !== this.loaded ) {
               this.hideElements();
               this.agreeHandler();
               this.allwaysHandler();

               this.loaded = true;
            }
        },

        agreeContent: function( gprdClass, slug ){
            var content = {
                'google-maps' : {
                    agreeNotice: '<p class="gprd-notice">Mit dem Laden der  Karte akzeptieren Sie die Datenschutzerklärung von Google.</p>',
                    privacyLink: '<p class="gprd-more"><a class="gprd-more-link" href="https://policies.google.com/privacy" target="_blank">Mehr erfahren</a></p>',
                    agreeBtn:    '<p class="gprd-agree-action"><input type="button" id="' + slug + '" size="5" class="agree-btn btn btn-md btn-secondary" value="Google Karte ansehen"></p>',
                    allwaysAgree: '<input class="allways-show form-check-input" type="checkbox" value="" id="cb-allways-' + slug + '"><label class="form-check-label" for="cb-allways-' + slug + '">Google Maps immer erlauben</label>',
                },

                'youtube' : {
                    agreeNotice: '<p class="gprd-notice">Mit dem Laden des Videos akzeptieren Sie die Datenschutzerklärung von YouTube.</p>',
                    privacyLink: '<p><a class="gprd-more-link" href="https://policies.google.com/privacy" target="_blank">Mehr erfahren</a></p>',
                    agreeBtn:  '<p><input type="button" id="' + slug + '" size="5" class="agree-btn btn btn-md btn-secondary" value="Abspielen"></p>',
                    allwaysAgree: '<input class="allways-show form-check-input" type="checkbox" value="" id="cb-allways-' + slug + '"><label class="form-check-label" for="cb-allways-' + slug + '">Youtube-Videos immer erlauben</label>',
                }
            };

            changedContent = $(document).triggerHandler( 'gprdAgreeContent', [content, gprdClass, slug] );

            content = changedContent ? changedContent : content;

            return $( '<div class="wrap-agree-content p-5 text-center"></div>' ) 
                    .append( content[gprdClass].agreeNotice )
                    .append( content[gprdClass].privacyLink )
                    .append( content[gprdClass].agreeBtn )
                    .append( content[gprdClass].allwaysAgree );
        },
            
        gprdClasses: function() {
            var slugs =  ['google-maps', 'youtube']; // with .gprd-agree

            return slugs;
        },

        gprdClassName: function( $mainContainer ) {
            var gprdClasses = this.gprdClasses();
            var result = false;

            gprdClasses.forEach( function( gprdClass ) {
                if ( $mainContainer.hasClass( gprdClass ) ) {
                    result = gprdClass;
                    return;
                }
            });

            return result;
        },

        hideElements: function() {
            var owner = this;
            var elementID = 0;
            var gprdClasses = this.gprdClasses();

            gprdClasses.forEach( function( gprdClass ) {
                var cookiePrefix = owner.cookiePrefix();
                var  triggerElements = [];

                $( '.' + gprdClass  + '.agree-gprd' ).each( function() {
                    var keyValue = document.cookie.match('(^|;) ?' + cookiePrefix + gprdClass + '=([^;]*)(;|$)');

                    if ( 'yes' === (keyValue ? keyValue[2] : null) ) {
                        triggerElements.push(this);

                        return;
                    }
                    
                    ++elementID;
                    var slug = gprdClass.replace( '.', '' ) + elementID;

                    $(this)
                        .data( 'class',  $(this).attr( 'class' ) ) //save attached classes 
                        //.removeClass();
                        .css( 'display', 'none' )
                        .wrap( '<div class="wrap-gprd-agree"></div>' );
                    
                    $(this)
                        .closest( '.wrap-gprd-agree' )
                        .addClass( $(this).data( 'class' ) ) // add attached corresponding classes to wrapper
                        .css( 'position', 'relative' )
                        .append( owner.agreeContent( gprdClass, slug ) );
                        
                });
                // Add trigger for handling
                if ( true === Array.isArray(triggerElements) ) {
                   $(document).trigger( 'gprdAgree', [triggerElements, gprdClass] );
                }
                 
            });
        },
        
        showElement: function( $mainContainer ) {
            //found gprd agree container then unwrap
            if ( $mainContainer.next( '.wrap-agree-content' ).length ) {
                $mainContainer.next( '.wrap-agree-content' ).remove();
                $mainContainer.unwrap();
                $mainContainer.removeAttr( 'style' );    
            }
        },
                
        showAllElements: function( gprdClass ) {
            var owner = this;
            var $agreeElements = [];
    
            $( '.wrap-gprd-agree' + gprdClass ).each( function() {
                $agreeElements.push( $(this).find( gprdClass + '.agree-gprd' ) );
                owner.showElement(  $agreeElements[$agreeElements.length-1] );
            })

            return $agreeElements;
        },
             
        agreeHandler: function() {
            var owner = this;
            
            $( '.wrap-agree-content' ).on( 'click', '.agree-btn', function() {
                $agreeElement = $(this).closest( '.wrap-gprd-agree' ).find( '.agree-gprd' );  

                owner.showElement( $agreeElement );
                
                var gprdClassName = owner.gprdClassName( $agreeElement );
                
                // Add trigger for handling
                $(document).trigger( 'gprdAgree', [[$agreeElement], gprdClassName] );
            });
            
        },
          
        allwaysHandler: function() {
            var owner = this;
            $( '.wrap-agree-content' ).on( 'click', '.allways-show', function() { //
                
                if ( $(this).prop( 'checked') ) {
                    
                    $agreeElement = $(this).closest( '.wrap-gprd-agree' ).find( '.agree-gprd' );

                    var gprdClassName = owner.gprdClassName( $agreeElement );
                    var $agreeElements = owner.showAllElements( '.'.concat( gprdClassName) );

                    // Add trigger for handlimg
                    $(document).trigger( 'gprdAgree', [$agreeElements, gprdClassName] );
                }

              document.cookie = owner.cookiePrefix() + gprdClassName  + '=yes ; path=/';
            }); 
        }
    };
	
	// Set iframe source from data	
	function assignIframeSrc( elements ) {
		if ( true === Array.isArray( elements ) ) {
            elements.forEach( function( element ) {

                $(element).prop({
                    src: $(element).data( 'src' )    
                });
            });
        }
    };
	
   // Handler GPRD Agreement		
   $( document ).on( 'gprdAgree', function( event, elements, agreeType ) {
	   assignIframeSrc( elements );
   });
	   
   ceOptInMediaWrapper.initialize();
	
		   
		   
})( jQuery, window, document );




/**
 * PopUp Contact Form Page Reloader
 *  
 * Monitors the AJAX-Request of the Contact Form and sets a flag when the message is sent successfully.
 * When closing the popup, it checks if the flag is set. If so, the page will be reloaded.
 * This ensures that the page is only reloaded after a successful submission of the form.
 */
document.addEventListener("DOMContentLoaded", function () {

    const popup = document.querySelector('.ce-contact-popup');
    if (
        popup &&
        popup.dataset.reloadAfterSubmit === 'true'
    ) {

        let formWasSuccessfullySent = false;

        jQuery(document).ajaxComplete(function (event, xhr, settings) {

            if (!settings?.data) return;

            if (settings.data.indexOf('et_pb_contactform_submit') !== -1) {

                const response = xhr.responseText || '';

                if (response.includes('et-pb-contact-message')) {
                    formWasSuccessfullySent = true;
                }
            }
        });

        const closeBtn = document.querySelector('.ce-contact-popup-close .et-pb-icon');

        if (!closeBtn) return;
        
        closeBtn.addEventListener('click', function () {

            if (formWasSuccessfullySent) {
                window.location.reload();
            }

            // optional reset for next usage (if no reload)
            formWasSuccessfullySent = false;
        });
        
    }
});

/**
 * Mega Menu 1.0
 */
;(function ( $, window, document, undefined ) {

var megaMenu = {
    initialize: function() {
    this.setMegaMenuPosition();
    this.bindEvents();
    },

    setMegaMenuPosition: function() {
        var menuBottom = $('#main-menu')[0].getBoundingClientRect().bottom;
        $('#box-mega-menu').css('top', menuBottom + 'px');
    },

    handleResizeScroll: function() {
    if ($('.btn-mega-menu').hasClass('opened')) {
        megaMenu.setMegaMenuPosition();
    }
    },

    toggleMegaMenu: function() {
    $('#box-mega-menu').slideToggle();
    $('.btn-mega-menu').toggleClass('opened closed');

    if ($('.btn-mega-menu').hasClass('opened')) {
        this.setMegaMenuPosition();
        $('body').css('overflow', 'hidden'); // Disable background scrolling
        $('#et-main-area').css("filter", "blur(5px) brightness(0.8)");

        // Activate resize and scroll event handlers
        $(window).on('resize scroll', this.handleResizeScroll);

        // Enable outside click event to close menu
        $(document).on('click.megaMenu', this.handleOutsideClick);
    } else {
        this.closeMegaMenu();
    }
    },

    closeMegaMenu: function() {
    $('#box-mega-menu').slideUp();
    $('.btn-mega-menu').removeClass('opened').addClass('closed');
    $('body').css('overflow', ''); // Re-enable background scrolling
    $('#et-main-area').css("filter", "none");

    // Deactivate resize and scroll event handlers
    $(window).off('resize scroll', this.handleResizeScroll);

    // Disable outside click event to close menu
    $(document).off('click.megaMenu', this.handleOutsideClick);
    },

    handleOutsideClick: function(e) {
    // Close menu only if the click is outside #box-mega-menu and .btn-mega-menu
    if (!$(e.target).closest('#box-mega-menu, .btn-mega-menu').length) {
        megaMenu.closeMegaMenu();
    }
    },

    bindEvents: function() {
    var self = this;

    // Toggle menu on button click
    $('.btn-mega-menu').click(function(e) {
        e.preventDefault();
        self.toggleMegaMenu();
    });
    }
};

$(document).ready(function () {
    // Initialize the mega menu
    megaMenu.initialize();



});

})( jQuery, window, document );


/***
 * Lightbox 1.0
 * 
 * Class Dependencies
 * 
 * LB Container: et-lb-content-[i]  
 * LB open button: et-lb-btn-[i]
 * 
 */
jQuery(function ($) {

    $(document).ready(function () {
        $('<span class="et-lb-close">M</span>').prependTo('body:not(.et-fb-root-ancestor) [class*="lb-content"]  > .et_pb_row:first-child');

        if ($('body:not(.et-fb-root-ancestor)').has('#et-boc').length) {
            $('body:not(.et-fb-root-ancestor) [class*="et-lb-content"]').wrapAll('<div id="et-boc" class="et-lb-wrapper"><div class="et-l"></div></div>');
            $('.et-lb-wrapper').appendTo('#et-main-area');
        } else {
            $('body:not(.et-fb-root-ancestor) [class*="et-lb-content"]').appendTo('#et-main-area');
        }

        $("[class*='et-lb-btn']").each(function (index, element) {
            var classes = $(element).attr('class').match(/et-lb-btn\-(\w*)/);
            if (classes !== null) {
                $(element).on('click', function (e) {
                    e.preventDefault();
                    // Lightbox öffnen und Scrollen verhindern
                    $('.et-lb-content-' + classes[1]).toggleClass('et-lb-open');
                    if ($('.et-lb-content-' + classes[1]).hasClass('et-lb-open')) {
                        $('body').css('overflow', 'hidden');
                    } else {
                        $('body').css('overflow', '');
                    }
                });
                
                // Lightbox schließen und Scrollen aktivieren
                $('.et-lb-close').click(function () {
                    $("[class*='et-lb-content']").removeClass('et-lb-open');
                    $('body').css('overflow', '');
                });
            }
        });







    });
});
